import { render, staticRenderFns } from "./MergeBagRow.vue?vue&type=template&id=44fc452a"
import script from "./MergeBagRow.vue?vue&type=script&lang=js"
export * from "./MergeBagRow.vue?vue&type=script&lang=js"
import style0 from "./MergeBagRow.vue?vue&type=style&index=0&id=44fc452a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports